export default "__VITE_ASSET__DBWXJVvP__"